import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import Byline from "@/common/article/byline"
import CTA from "@/common/article/cta"
import Terms from "@/common/article/terms"
import Like from "@/common/social/like"
import Share from "@/common/social/share"
import styles from "./calendar-single.module.css"

export default function EventMeta({ block }) {
  const object = usePropsObject()

  return (
    <Block block={block} width="column" gap="small" className={styles.meta}>
      <CTA data={object.cta} />
      <Terms terms={object.terms} className="terms" />
      <div className="items-center justify-between mt-6 mb-6 sm:flex">
        <Like id={object.id} likes={object.likes} />
        <Share classes="mr-2 w-icon h-icon" url={object.url} />
      </div>
      {object.byline && <Byline byline={object.byline} />}
    </Block>
  )
}
